<template>
  <div class="tier-selector mt-2">
    <div class="dropdown position-relative">
      <button
        class="dropdown-toggle d-flex justify-content-between align-items-center w-100"
        type="button"
        id="tier-select-btn"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <span v-html="store.selectedTier.title"></span>
        <img :src="`${store.baseUrl}/images/icon_caret-down.png`" class="arrow" alt="">
      </button>
      <div class="dropdown-menu w-100 p-0" aria-labelledby="tier-select-btn">
        <div class="d-flex flex-column align-items-start">
          <button
            class="option w-100"
            v-for="(tier, index) in selectableTiers"
            :key="index"
            @click="selectTier($event)"
            @keydown.enter="selectTier($event)"
            v-html="tier.title"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from '../store';

const store = useStore();

const selectableTiers = computed(() => {
  let arr = store.selectedCard.calculator.tiers.filter(tier => {
    return tier.title !== store.selectedTier.title;
  });
  return arr;
});

const emit = defineEmits(['tierUpdated']);

function selectTier(e) {
  store.selectedCard.calculator.tiers.map(tier => {
    if (tier.title === e.target.innerHTML) {
      store.selectedTier = tier;
    }
  });
  emit('tierUpdated');
}
</script>
